import React, { FC } from 'react'

import { IconPassTicketProps } from './IconPassTicket.types'
import * as Styled from './styles/IconPassTicket.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPassTicket: FC<IconPassTicketProps> = ({
  size = nonThemeableRules.defaultSize as number as IconPassTicketProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconPassTicketProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M119.57 23.18a4 4 0 0 0 0-5.66L109.18 7.13a9 9 0 0 0-12.73 0L7.28 96.3a9 9 0 0 0 0 12.73l10.39 10.39a4 4 0 0 0 5.59.07 12 12 0 0 1 17 17 4 4 0 0 0 .04 5.51l10.82 10.82a9 9 0 0 0 12.73 0l5.94-5.94 1.7-1.7 11.38-11.38 1.36-1.36L153 63.7a9 9 0 0 0 0-12.7l-10.87-10.92a4 4 0 0 0-5.66 0 12 12 0 1 1-16.9-16.9zm19.52 25.17 8.27 8.27a1 1 0 0 1 0 1.41L131.31 74.1a4 4 0 0 0-5.66 5.66l-47.08 47.07-1.36 1.36-11.38 11.38-1.7 1.7-5.94 5.94a1 1 0 0 1-1.41 0l-8.41-8.41a20 20 0 0 0-27.58-27.58l-7.85-7.85a1 1 0 0 1 0-1.41L80.4 34.5l.28.28a4 4 0 0 0 5.66-5.66l-.28-.28 16.05-16.05a1 1 0 0 1 1.41 0l7.85 7.85a20 20 0 0 0 27.72 27.72z' />
        <circle cx='116.95' cy='65.4' r='4' transform='rotate(-45 116.949 65.398)' />
        <circle cx='105.5' cy='53.94' r='4' transform='rotate(-45 105.502 53.94)' />
        <circle cx='93.97' cy='42.42' r='4' transform='rotate(-45 93.97 42.417)' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconPassTicket
